import { useShallow } from 'zustand/react/shallow'

import { Controls } from './Controls'
import { useCADPageStore } from '@/state'
import { CreateViewButton } from './CreateViewButton'
import { RetakeViewButton } from './CreateViewButton/RetakeViewButton'

export const ControlPanel = () => {
  const isRetakeModeActive = useCADPageStore(
    useShallow((state) => state.isRetakeModeActive),
  )

  return (
    <div
      className="absolute bottom-0 z-20 pointer-events-auto select-none"
      style={{ right: 0, left: 0, bottom: 5, transform: 'none !important' }}
    >
      <div className="flex justify-center bg-transparent w-full">
        <div className="flex items-center space-x-0 py-1 px-0 border shadow-md rounded-full bg-white">
          <Controls />
          <div className="pr-1">
            {isRetakeModeActive ? <RetakeViewButton /> : <CreateViewButton />}
          </div>
        </div>
      </div>
    </div>
  )
}
